module.exports = __webpack_public_path__ + "c0ac26dcf8b1d38162ff33b7ff5308c7.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/logdesign/img/top_logo.png
// module id = 1767
// module chunks = 1